<template>
    <div id="app">
        <v-card flat id="main-container">

            <div class="main-selection-div">
                <v-card dark ripple class="card-area">
                    <div class="selection-icon">
                        <v-icon style="font-size: 20vh">far fa-clone</v-icon>
                    </div>
                    <div class="selection-text">
                        Quick Copy
                    </div>
                </v-card>
            </div>

            <div class="main-selection-div">
                <v-card dark ripple class="card-area">
                    <div class="selection-icon">
                        <v-icon style="font-size: 20vh">fas fa-th-list</v-icon>
                    </div>
                    <div class="selection-text">
                        Order Status
                    </div>
                </v-card>
            </div>

            <div class="main-selection-div">
                <v-card dark ripple class="card-area">
                    <div class="selection-icon">
                        <v-icon style="font-size: 20vh">fas fa-bullhorn</v-icon>
                    </div>
                    <div class="selection-text">
                        Announcements
                    </div>
                </v-card>
            </div>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueApexCharts from 'vue-apexcharts'

Vue.use(Vuetify)
Vue.use(VueApexCharts)
export default {

  components: {
    apexcharts: VueApexCharts
  },

  data () {
    return {

    }
  },
  watch: {

  },
  created: function () {
    document.title = 'Chattube - Help'
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style scoped>
    html, body {
        height: 100%;
        margin: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        text-align: center;
        color: black;
        background-color: white;

        width: 100%;
        height: 100%;
        background-size: cover;
        overflow: hidden;
        padding: 1%;
    }
    .main-selection-div {
        width: 33.3%; height: 100%; float: left;
        display: flex; justify-content: center; align-items: center;
    }
    .selection-icon {
        width: 100%; height: 60%; display: flex; justify-content: center; align-items: center
    }
    .selection-text {
        color: white;width: 100%; height: 40%; display: flex; justify-content: center; align-items: center; font-size: 5vh; font-weight: bold
    }
    .card-area {
        height: 80%;
        width: 90%;
    }
    #main-container {
        width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
        padding-left: 5%;
        padding-right: 5%;
    }
</style>